import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#CF0A2C',
    },
    background: {
      default: '#FFFFFF', // Colore di sfondo principale
      paper: '#FAFAFA',   // Colore per il background delle card
    },
    text: {
      primary:'#333333',
      secondary: '#919599', // Colore di testo supporto (supportText)
    },
    custom: {
      blue: '#5AA1F3',      // Aggiungiamo il colore personalizzato blue
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '15px',     // Imposta la dimensione del font
          fontWeight: 500,      // Imposta il peso del font
        },
      },
    },}
  
});

// Estendere il tipo di tema per includere il colore custom.blue
declare module '@mui/material/styles' {
  interface Palette {
    custom?: {
      blue?: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      blue?: string;
    };
  }
}
